module.exports = __webpack_public_path__ + "img/untitled.499.8f3f266b.png";